<template>
    <header class="mdc-top-app-bar view-header"
        :style="paperData.image ? `background-image: url(${paperData.image}?s=360x256&t=fill&q=10&b=5);` : ''"
        :class="paperData.image ? 'darken' : ''"
        v-if="paperData"
        >

        <div class="mdc-top-app-bar__row">
            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                <a class="material-icons mdc-top-app-bar__navigation-icon" @click="routerGoPrev()">arrow_back</a>
            </section>
            
            <section class="mdc-top-app-bar__section title">
                <div class="mdc-top-app-bar__title"></div>                
            </section>

            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                <!-- <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a> -->
            </section>
        </div>
        <div class="pdt-16 pdb-20 pdl-16 pdr-16">
            <div class="t-headline14">
                {{paperData.name}}
            </div>
            <div class="t-body4 mgt-8" v-if="paperData.category">
                {{paperData.category.text}}
                {{paperData.category.child ? ' > ' + paperData.category.child.text : ''}}
            </div>

            <div class="t-body4 mgt-4" v-if="paperData.level">
                {{paperData.level.text}}
            </div>
            
                <div class="mdc-chip-set " role="grid"  v-if="paperData.tags.length">
                    <div class="mdc-chip mdc-chip-outline" role="row" v-for="(tag, index) in paperData.tags" :key="index">
                        <div class="mdc-chip__ripple"></div>
                        <span role="gridcell">
                            <span class="mdc-chip__text">#{{tag.name}}</span>
                        </span>
                    </div>
                </div>

            <!-- <div class="t-helper mgt-9 d-flex flex-row" v-if="paperData.tags.length">
                <span class="chip mgr-8" v-for="(tag, index) in paperData.tags" :key="index">#{{tag.name}}</span>
            </div> -->

            <div class="mgt-18 d-flex flex-row justify-content-between align-items-baseline"  v-if="paperData.goods && !examineeId">
                <div class="t-body3" v-if="isCharged">
                    
                    {{paperData.goods.currency.key || 'USD'}}
                    <span class="t-headline5">
                        {{$n(paperData.goods.paymentPrice)}}
                        <!-- 결제금액 -->
                    </span>
                    <span class="t-body3 t-line-through-red mgr-7 mgl-7" v-if="paperData.goods.paymentPrice !== paperData.goods.price">
                        {{$n(paperData.goods.price)}}
                        <!-- 정가 -->
                    </span>
                    
                </div>
                <div class="t-headline5" v-else>
                    <!-- FREE -->
                    {{$t('1010')}}
                </div>
                
            </div>

            <div v-if="paperData.goods">
                <div class="mgt-14 ripple-item" v-if="!examineeId">
                    <button class="   mdc-button mdc-button--raised btn-red w-full " 
                            v-if="isCharged"
                            @click="buyExam()"
                    >
                        {{$t('1002')}}
                        <!-- 구매하기 -->
                    </button>

                    <button class=" mdc-button mdc-button--raised btn-red w-full " 
                        v-else
                        @click="buyExam()"
                    >
                        {{$t('1011')}}
                        <!-- 신청하기 -->
                    </button>
                    <!-- {{isCharged}} -->
                </div>

                <div class="" v-else>
                    <div v-for="(action, index) in actions" :key="index">
                        <button v-if=" action.action != 'can_re_start' && action.action != 'after_confirm' " class="mdc-button mdc-button--raised  w-full mgt-14" :disabled="setButtonDisabled(action)" :class="{'bg-disableBtn disabled  t-color-disableBtnText':setButtonDisabled(action) ,'btn-red':!setButtonDisabled(action)}"  @click="examAction(action)">
                            {{setButtonActionName(action)}}
                        </button>  
                  
                    </div>
                    <!-- {{isCharged}} -->
                </div>
            </div>

        </div>
        
        <!-- {{paperData}} -->
    </header>

</template>

<script>
import httpService from '@/api/httpService'
import loginApi from '@/api/loginApi.js'
import degreeApi from '@/api/degreeApi.js'
import salesApi from '@/api/salesApi.js'
import {examMixin} from '@/mixins/exam.js'
import {MDCRipple} from '@material/ripple'
import {MDCChipSet} from '@material/chips';
export default {
    props: ['paperData','examineeId','actions'],
    data() {
        return {
            price: 0
        }
    },
    mixins: [examMixin],

    mounted() {
        // this.price = this.paperData.price
        console.log('this.paperData', this.paperData);
        this.setMaterialUi()
       const chipSetEl = document.querySelector('.mdc-chip-set');
       const chipSet = new MDCChipSet(chipSetEl);
        
    },

    computed: {
        isCharged() {
            return this.paperData.goods ? !!this.paperData.goods.paymentPrice : false
        }
    },

    methods: {
        async buyExam() {
            // console.log(await this.checkLogin());
            let authStatus = await this.checkLogin()
            if (authStatus) {
                console.log('중복체크');
                salesApi.salesGoodsPurchased({goodsId: this.paperData.goods.id,fetchType:'EXAM'}).then((response) => {
                    let purchasedData = response.data.data
                    // console.log('purchasedData',purchasedData); return


                    if (purchasedData.length) {
                        this.$router.push({
                            name: 'SalesDuplicate', 
                            params: {goodsid: this.paperData.goods.id}, 
                            query: this.$route.query
                        })
                        return false
                    }

                    this.$router.push({
                        name: 'SalesInformation', 
                        params: {goodsid: this.paperData.goods.id}, 
                        query: this.$route.query
                    })
                    
                }).catch((err) => {

                })
                
            }else {
                this.moveLogin()
            }
        },

        checkLogin() {
            // httpService.setAuthInHeader(localStorage.getItem('token'))
            return new Promise((resolve, reject) => {
                loginApi.validToken().then((response) => {
                    resolve(true)
                }).catch((err) => {
                    resolve(false)
                })
            })
            

        },

        moveLogin() {
            const loginPath = `/login?redirectPath=${encodeURIComponent(this.$route.fullPath)}`
            this.$router.push(loginPath)
        },


        setButtonActionName(action) {
            //before_start : ~부터 응시가능
            //can_start : 응시
            //can_re_start : 재응시
            //before_confirm : ~부터 결과확인 가능
            //open_confirm : 결과확인
            let buttonName = ''
            if (action.action === 'before_start') {
                buttonName = this.$t('531', {str: this.$moment(action.data.application_start_time).format('ll')}) //  + '{날짜}부터 응시가능'
            }else if (action.action === 'can_start') {
                //buttonName = this.$t('50008') //'응시'
                buttonName = this.$t('524') //'응시'
            }else if (action.action === 'can_re_start') {
                buttonName = this.$t('50009') //재응시'
            }else if (action.action === 'before_confirm') {
                buttonName = this.$t('3080', {str: this.$moment(action.data.confirm_start_time).format('ll')}) // '~부터 결과확인 가능'
            }else if (action.action === 'open_confirm') {
                buttonName = this.$t('50012') //'결과확인'
            }
            else if (action.action === 'after_confirm') {
                buttonName = this.$t('3080', {str: this.$moment(action.data.confirm_start_time).format('ll')}) // '~부터 결과확인 가능'
            }
            else if (action.action === 'after_end') {
                buttonName = this.$t('3080', {str: this.$moment(action.data.confirm_start_time).format('ll')}) // '~부터 결과확인 가능'
            }
            return buttonName
        },

        setButtonDisabled(action) {
            return action.action === 'before_start' || action.action === 'before_confirm' || action.action === 'after_end' ? true : false
        },

        examAction(action) {
            if (action.action === 'can_start' || action.action === 'can_re_start') {
                this.startExam()
            }else if (action.action === 'open_confirm') {
                //this.startExam()
                console.log('결과보기로 ㄱㄱ');
                this.moveExamResult()
                
            }
        },

        moveExamResult() {
            let query = this.$route.query;
            query.type='independent'
            this.$router.push({
                name: 'IndependentExamIntro', 
                query: query
            })
        },

        startExam() {
            let query = this.$route.query;
            query.type='independent'
            this.$router.push({
                name: 'IndependentExamIntro', 
                query: query
                // params: {learnId: this.$route.params.learnId},
                // query: this.$route.query
            })
        },
        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
            
        },
    },
    



}
</script>

<style>

</style>
